import { Component } from '@angular/core';
import { FaqRoutingEnum } from '@app/core/enums/faq-routing.enum';
import { CarouselInterface } from '@app/core/interfaces';
import * as items from './claims-overview-content.json';
import { contactQueryParams } from '@inshared/shared/util';
import { AppRoutesEnum, ContactCategoryEnum } from '@inshared/shared/core';

@Component({
    selector: 'ins-claims-overview-content',
    templateUrl: './claims-overview-content.component.html',
    styleUrls: ['./claims-overview-content.component.scss'],
})
export class MyClaimsOverviewContentComponent {
    public items: CarouselInterface[];
    public faqRoutingEnum = FaqRoutingEnum;

    constructor() {
        this.items = items['default'];
    }

    protected readonly contactQueryParams = contactQueryParams;
    protected readonly AppRoutesEnum = AppRoutesEnum;
    protected readonly ContactCategoryEnum = ContactCategoryEnum;
}
